import { useCompanyAllowlist } from "./UseCompanyAllowlist";

const BETA_TESTERS: string[] = [
  // '24adbc1c-904c-4091-ba95-46323cd04431', // TT Prod
  // '692b0efb-b3ae-4656-a11b-e37ae599a636', // TT Test
  'e6a78370-0089-41c1-a01b-d7abf47cb01d', // Added 2026-10-02
];

export function IsBetaTester() {
  return useCompanyAllowlist(BETA_TESTERS);
}
